import { api } from "@";

// Function to get a list of users with pagination and search
export const getUsers = (page = 1, perSize, search) => {
  return api.post("/api/AdminUser/users/search-admins", {
    page: page,
    pageSize: perSize,
    searchKey: search,
  });
};

// Function to get a specific user's permissions by ID
export const getUser = (id) => api.get(`/api/AdminPermission/${id}`);

// Function to save a user's data (create or update)
export const saveUser = (form) => {
  delete form.type;
  if (form.id) {
    return api.put(`/api/AdminUser/${form.id}/request-otp-update`, form);
  }
  return api.post("/api/AdminUser/users/create-with-permission", form);
};

// Function to save a user's permissions
export const saveUserPermission = (data, id) => {
  const payload = data.permissions;
  payload.userId = id;
  return api.put(`/api/AdminPermission/${id}`, data.permissions);
};
